import jwt from "jwt-decode";
import { getApi, postApi } from "./auth_helpers";

export const persistStudioTokens = (tokens: { token?: string; refreshToken?: string }) => {
  if (!tokens?.token) {
    return;
  }
  localStorage.setItem("token", tokens.token);
  if (tokens.refreshToken) {
    localStorage.setItem("refreshToken", tokens.refreshToken);
  }
  const decoded: any = jwt(tokens.token);
  localStorage.setItem("authUser", JSON.stringify(decoded));
};

export const refreshStudioEntitlements = async (): Promise<boolean> => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  const url = `${process.env.REACT_APP_SERVERURL}/saas/me`;
  const response: any = await getApi(url);
  if (!response?.success || !response?.data?.tokens) {
    return false;
  }
  persistStudioTokens(response.data.tokens);
  return true;
};

/** First open of a module the studio may still try (Karkhana): starts its trial once, then refreshes tokens. */
export const startStudioModuleTrial = async (moduleId: string): Promise<boolean> => {
  const url = `${process.env.REACT_APP_SERVERURL}/saas/modules/${encodeURIComponent(moduleId)}/start-trial`;
  const response: any = await postApi(url, {});
  if (!response?.success || !response?.data?.tokens) {
    return false;
  }
  persistStudioTokens(response.data.tokens);
  return Boolean(response.data.entitled);
};
